import { useMemo } from 'react'
import { useIncidents } from '../../incidents/hooks/useIncidents'
import { useCurrentShift } from './useCurrentShift'
import { aggregateShiftKpis } from '../utils/aggregateShiftKpis'
import { selectCriticalIssues, selectBlockedTasks, type CriticalIssueVM, type BlockedTaskVM } from '../utils/incidentSelectors'
import type { ShiftKpis, ShiftResponse } from '../types/shift.types'

export interface ShiftDataResult {
  shift: ShiftResponse | null
  kpis: ShiftKpis | null
  critical: CriticalIssueVM[]
  blocked: BlockedTaskVM[]
  isLoading: boolean
  isError: boolean
  refetch: () => void
}

export function useShiftData(): ShiftDataResult {
  const shiftQuery = useCurrentShift()
  const incidentsQuery = useIncidents()

  const shift = shiftQuery.data ?? null
  const incidents = incidentsQuery.data ?? []

  const derived = useMemo(() => {
    return {
      kpis: shift ? aggregateShiftKpis(incidents, shift) : null,
      critical: selectCriticalIssues(incidents),
      blocked: selectBlockedTasks(incidents),
    }
  }, [incidents, shift])

  return {
    shift,
    kpis: derived.kpis,
    critical: derived.critical,
    blocked: derived.blocked,
    isLoading: shiftQuery.isLoading || incidentsQuery.isLoading,
    isError: shiftQuery.isError || incidentsQuery.isError,
    refetch: () => {
      void shiftQuery.refetch()
      void incidentsQuery.refetch()
    },
  }
}
